import type { ContactType } from '@api';

export const hasRenderableContact = (contact: ContactType | null): boolean => {
  if (!contact) return false;

  return Boolean(
    contact.phone || contact.mobile || contact.email || contact.fax
  );
};
